import React from "react";

export default function AvatarPlaceholderIcon() {
  return (
    <svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M29.75 30.75C28.8317 13.2506 1.66833 13.2506 0.75 30.75M21.05 6.375C21.05 7.86684 20.4389 9.29758 19.3512 10.3525C18.2635 11.4074 16.7883 12 15.25 12C13.7117 12 12.2365 11.4074 11.1488 10.3525C10.0611 9.29758 9.45 7.86684 9.45 6.375C9.45 4.88316 10.0611 3.45242 11.1488 2.39752C12.2365 1.34263 13.7117 0.75 15.25 0.75C16.7883 0.75 18.2635 1.34263 19.3512 2.39752C20.4389 3.45242 21.05 4.88316 21.05 6.375Z" 
        stroke="white" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}
